import React from 'react'
import { useLocation } from 'react-router-dom'

import useMemoizedSelector from '~/hooks/use-memoized-selector'
import { getFeatureFlags } from '~/selectors/feature-flags'

import OrderSummaryComponent from './order-summary.component'

import type { AppState } from '~/reducers'

type SelectorProps = {
  adventureAssuranceCreditEnabled: boolean
}

function mapStateToProps(state: AppState): SelectorProps {
  const { adventureAssuranceCreditEnabled } = getFeatureFlags(state)

  return {
    adventureAssuranceCreditEnabled,
  }
}

const OrderSummary = (props) => {
  const { pathname } = useLocation()
  const combinedProps = {
    ...props,
    ...useMemoizedSelector(mapStateToProps),
    displayAffirm: pathname?.match(/\/cart/),
  }

  return <OrderSummaryComponent {...combinedProps} />
}

export default OrderSummary
